import { AddProductsToCartMutation } from '@notino/shared/definitions/types';

import { AddToCartProductErrors } from '../../../model';
import { generateNotificationMessageForProduct } from '../../../utils';
import { IAddToCartResult } from '../model';

const nonFatalAddToCartProductErrors = [
  AddToCartProductErrors.SC_INSURANCE_ADD_ERROR,
  AddToCartProductErrors.SC_ECO_PACKAGING_ADD_ERROR,
];

const onlyFatalErrors = (m: AddToCartProductErrors) =>
  !nonFatalAddToCartProductErrors.includes(m);

export function createNotificationMessages(
  products: IAddToCartResult['products'],
  productById: (
    id: string
  ) => AddProductsToCartMutation['AddProductsToCart']['productAddResponse'][number]
) {
  return products
    .map((product) => {
      const productFatalErrors = productById(product.id).messages.filter(
        onlyFatalErrors
      );

      if (productFatalErrors.length === 0) {
        return null;
      }

      return generateNotificationMessageForProduct(productFatalErrors, product);
    })
    .filter(Boolean);
}

export const hasFatalError = (
  products: AddProductsToCartMutation['AddProductsToCart']['productAddResponse']
) => {
  return (
    products
      .map((product) => product.messages)
      .flat()
      .filter(onlyFatalErrors).length > 0
  );
};
